import React, { Component } from 'react';
import { Segment, Form } from 'semantic-ui-react';
import './DevDashBoard.css'

class DevDashBoard extends Component {
    
    render() {

        if(!this.props.show) return null;


        return (
            <Segment className="DevDashBoard" raised>
                <Form>
                    <Form.Group>
                        <Form.Field>
                            <Form.Button
                                onClick={() => this.props.addNewBox()}
                                disabled={this.props.addNewBoxDisabled}
                                color="teal" >
                                Ny låda har kommit
                            </Form.Button>
                        </Form.Field>
                        <Form.Field>
                            <Form.Button color="teal" onClick={() => this.props.logState()}>Log state</Form.Button>
                        </Form.Field>
                    </Form.Group>
                </Form>
            </Segment>
        );
    }
}

export default DevDashBoard;